import * as r from "react";
import { i as t, E as d, x as i, d as n, c as l } from "../createReactComponent-58f9bea8.mjs";
import { e as o } from "../class-map-2994e95e.mjs";
import { S as c } from "../slot-controller-fa97ce97.mjs";
const m = t`
  :host .card {
    background-color: var(--exo-color-background);
    width: 100%;
    min-height: var(--exo-size-1);
    overflow: hidden;
    border-radius: calc(4 * var(--exo-radius-small));
    border: var(--exo-spacing-4x-small) solid var(--exo-color-border-secondary);
    box-shadow: var(--exo-box-shadow-weak);
    transition: box-shadow var(--exo-time-standard) ease;
    user-select: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    box-sizing: border-box;
    position: relative;
  }

  :host .card:hover,
  :host .card:focus-within {
    box-shadow: var(--exo-box-shadow-moderate);
    transition: box-shadow var(--exo-time-standard) ease;
  }

  :host .card__body {
    display: flex;
    flex-direction: column;
    padding: var(--exo-spacing-standard) var(--exo-spacing-medium);
    gap: var(--exo-spacing-2x-small);
  }

  :host .card__footer {
    display: flex;
    padding: var(--exo-spacing-none) var(--exo-spacing-medium)
      var(--exo-spacing-medium) var(--exo-spacing-medium);
    flex-direction: column;
    gap: calc(0.5 * var(--exo-spacing-medium));
  }

  :host .hide {
    display: none;
  }
`;
class e extends d {
  constructor() {
    super(...arguments), this.slotController = new c(this, "footer", "header");
  }
  render() {
    const a = { card__header: !0, hide: !this.slotController.test("header") }, s = { card__footer: !0, hide: !this.slotController.test("footer") };
    return i`
      <div class="card">
        <div class=${o(a)}>
          <slot name="header"></slot>
        </div>

        <div class="card__body">
          <slot></slot>
        </div>

        <div class=${o(s)}>
          <slot name="footer"></slot>
        </div>
      </div>
    `;
  }
}
e.styles = m;
const x = n("ex-card", e), u = l({ tagName: "ex-card", elementClass: e, react: r, events: {}, displayName: "ExCard", registerWebComponent: x });
export {
  u as ExCard,
  x as register
};
